var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNgjitje(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.48,
    height: 20.832,
    viewBox: "0 0 28.48 20.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6478",
    "data-name": "Group 6478",
    transform: "translate(-457.623 -794.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9143",
    "data-name": "Path 9143",
    d: "M28.48,216.806v2.624H0V203.992H5.236a.467.467,0,0,1,.467.467v2.624h5.236a.467.467,0,0,1,.467.467v2.624h5.236a.467.467,0,0,1,.467.467v2.624h5.2a.467.467,0,0,1,.467.467v2.606h5.236a.467.467,0,0,1,.467.467",
    transform: "translate(457.623 595.986)",
    fill: "#20AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9144",
    "data-name": "Path 9144",
    d: "M677.919,13.4l.848-3.122a.787.787,0,0,1,.5-.537l1.81-.629-.236-2.487L679.2,8.586a.584.584,0,0,1-.9-.748l2.405-2.883a1.64,1.64,0,0,1,.816-1.278,1.837,1.837,0,1,1,.85-.217,1.761,1.761,0,0,1,1.535,1.131c.438.9.883,1.8,1.314,2.7l.885,1.78a.584.584,0,1,1-1.046.52l-.807-1.623c.05.524.118,1.05.149,1.576,0,.034,0,.068.006.1l3.386,6.6a.787.787,0,1,1-1.4.719l-3.237-6.31a.678.678,0,0,0-.832-.329c-.794.284-2.153.761-2.153.761l-.739,2.721a.787.787,0,1,1-1.519-.412",
    transform: "translate(-202.344 794.584)",
    fill: "#20AC9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgjitje);
export default __webpack_public_path__ + "static/media/ngjitje.a49b4c44e6d232a1606d225b687abdf4.svg";
export { ForwardRef as ReactComponent };